<template>
	<div class="bottom-area" :style="{ paddingBottom: safeAreaInsetBottom + 15 + 'px' }">
		<div class="no-available-tips" v-if="!available">
			<nio-icon name="icon_information_2xs" :size="16" style="color: #25CBC5" />
			<span>该车辆已被用户预订，建议关注其他相关推荐</span>
		</div>
		<div class="bottom-area-inner">
			<!-- <div
				class="contact-btn"
				:class="{ collected }"
				v-open-launch-app
				@click="handleContactOfficial"
				v-sd-clk:MallItemDetailClick="{
					page: '二手车车辆详情页',
					sku_code: car.basic.commodity_code,
					button_name: '联系客服',
					track_sign: 'aMall.b30.d33.click.SecondCarClick'
				}"
			>
				<nio-icon :size="28" name="icon_commentary_medium_m" />
				<p>咨询</p>
			</div> -->

			<div
				class="star-btn"
				:class="{ collected }"
				v-open-launch-app
				@click="handleSwitch"
				v-sd-clk:VehicleDetailClick="{
					page: '二手车车辆详情页',
					label_name: car.$$track_label_name,
					tag: car.$$track_tags,
					module_name: '页面底部',
					button_name: '收藏',
					position_rank: 8,
					position_in_rank: 1,
					position_in_number: 1,
					track_sign: 'aMall.b4307.click.VehicleDetailClick'
				}"
			>
				<nio-icon v-if="!collected" :size="28" name="icon_star_m" />
				<nio-icon v-else :size="28" name="icon_star_filled_m" />
				<p>收藏</p>
			</div>
			<nio-button
				v-if="car.basic.business_type === 1"
				v-open-launch-app
				@click="handleOrder"
				round
				:disabled="!available"
				v-sd-clk:VehicleDetailClick="{
					page: '二手车车辆详情页',
					label_name: car.$$track_label_name,
					tag: car.$$track_tags,
					module_name: '页面底部',
					button_name: '立即预订',
					position_rank: 8,
					position_in_rank: 1,
					position_in_number: 1,
					track_sign: 'aMall.b4307.click.VehicleDetailClick'
				}"
			>
				立即预订
			</nio-button>
			<nio-button
				v-if="[2, 4].includes(car.basic.business_type)"
				v-open-launch-app
				@click="handleContactSeller"
				v-sd-clk:VehicleDetailClick="{
					page: '二手车车辆详情页',
					label_name: car.$$track_label_name,
					tag: car.$$track_tags,
					module_name: '页面底部',
					button_name: '联系卖家',
					position_rank: 8,
					position_in_rank: 1,
					position_in_number: 1,
					track_sign: 'aMall.b4307.click.VehicleDetailClick'
				}"
			>
				联系卖家
			</nio-button>
		</div>
	</div>
</template>

<script>
import { cancelCollectCar, collectCar, queryVehicleDetail, checkPayStatus } from '@/model'
import util from '@/util/util'
import hybrid from '@/util/nativeHybrid'
import { mapActions, mapMutations, mapState } from 'vuex'
import { allCarDisabledStatus, allCarStatus } from '@/views1/IndexPage/filterOptions'
import link from '@/util/link'
import { getSafeInsetBottom } from '@/util/unit-transfer'

export default {
	name: 'BottomArea',
	props: ['car'],
	data() {
		return {
			loading: false,
			safeAreaInsetBottom: getSafeInsetBottom()
		}
	},
	created() {
		// this.collected = this.car.basic.is_favorite;
	},

	computed: {
		...mapState('homeState', {
			collectedRecord: state => state.collectedRecord,
			cancelCollectRecord: state => state.cancelCollectRecord
		}),

		collected() {
			if (this.collectedRecord.indexOf(this.car.basic.commodity_code) >= 0) {
				return true
			}

			if (this.cancelCollectRecord.indexOf(this.car.basic.commodity_code) >= 0) {
				return false
			}
			return this.car.basic.is_favorite
		},

		available() {
			return !allCarStatus.some(one => one.value === this.car.status.commodity_status)
		}
	},
	methods: {
		...mapMutations('homeState', ['cancelCollect', 'collect']),
		...mapActions('homeState', ['switchCollect']),

		async handleSwitch() {
			if (!util.isInWebview()) {
				return
			}
			if (!util.isToken()) {
				hybrid.openLoginPage()
				return
			}

			if (this.loading) {
				return
			}

			this.loading = true
			try {
				const commodity_code = this.car.basic.commodity_code

				await this.switchCollect({
					commodity_code,
					curCollected: this.collected
				})

				if (this.collected) {
					this.$toast('收藏成功')
				} else {
					this.$toast('已取消收藏')
				}
			} catch (e) {
				this.$toast(e.message)
			} finally {
				setTimeout(() => {
					this.loading = false
				}, 1500)
			}
		},

		handleContactOfficial() {
			if (!util.isInWebview()) {
				return
			}
			this.$emit('contact')
		},
		async getLatestStatus() {
			try {
				const { data } = await queryVehicleDetail.get({}, '/' + this.car.basic.commodity_code)

				if (!data || data.result_code !== 'success') {
					throw new Error()
				}
				const car = data.data

				return car.status.commodity_status
			} catch (e) {
				return this.car.status.commodity_status
			}
		},

		async handleOrder() {
			if (util.isInWebview()) {
				await util.checkLogin()

				// 校验商品状态
				// const latestStatus = await this.getLatestStatus()
				// if (allCarStatus.some(one => one.value === latestStatus)) {
				// 	const statusName = allCarStatus.find(one => one.value === latestStatus).label
				// 	this.$toast('车辆' + statusName)
				// 	return
				// }

				try {
					// 校验订金是否被支付
					const { data } = await checkPayStatus.get({}, `/${this.car.basic.commodity_code}`)
					if (!data || data.result_code !== 'success') {
						throw new Error()
					}

					if (data.data.is_payed === true) {
						this.$toast('该车辆已被抢定了，可以看看其他车辆哦')
						return
					}

					// hybrid.openURL(`localhost:8080/#order-creator?wv=do&vin=${vidcode}`);
					link.goToRoute('/orderCreator', {
						sku_code: this.car.basic.commodity_code
					})
				} catch (error) {
					console.log(`error ===> `, error)
				}
			}
		},

		handleContactSeller() {
			if (!util.isInWebview()) {
				return
			}
			if (!this.car.basic.owner_account || this.car.basic.consultation_type !== 1) {
				hybrid.showToast('车主不便直接联系，请咨询牛小二')
				return
			}

			if (!util.isToken()) {
				hybrid.openLoginPage(() => {
					this.openThirdImChat(this.car.basic.owner_account)
				})
			} else {
				this.openThirdImChat(this.car.basic.owner_account)
			}
		},
		openThirdImChat(accountId) {
			const basic = this.car.basic
			const price = ` ¥ ${util.formatCurrency(this.car.sell_programme.sell_price)}`
			const title = `${basic.commodity_name || ''}(${price})`
			let configs = []
			if (basic.battery_desc) {
				configs.push(basic.battery_desc)
			}
			configs.push(basic.is_baas ? '电池租用' : '整车购买')
			const desc = configs.join('|')

			let img_url = ''
			const appearance = (this.car.photo || {}).appearance || {}
			;(appearance.items || []).forEach(item => {
				if (item.orientation === 1) {
					img_url = item.thpf_url
				}
			})

			const share_nio_url =
				util.getBaseEnvInfo().openUrl +
				`/module_10021/detail?is_nav_show=false&sku_code=${basic.commodity_code}&is_favorite=${basic.is_favorite}`
			const share_message_json = encodeURIComponent(
				JSON.stringify({
					title,
					desc,
					img_url,
					share_nio_url,
					default_url: share_nio_url
				})
			)

			const suffixArr = ['-test', '-test', '-staging', '-prod']
			const env = util.getEnv()
			const url = `nio://conversation?id=${encodeURIComponent(accountId)}${suffixArr[env] ||
				''}&type=private&brand=nio&need_show_send_card=true&share_message_json=${share_message_json}`
			console.log('share_nio_url ===> ', share_nio_url)
			console.log('openThirdImChat ===> ', url)
			hybrid.openURL(url)
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.bottom-area {
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: #ffffff;
	padding-left: 28px;
	padding-right: 20px;

	&-inner {
		height: 75px;
		display: flex;
		align-items: center;

		.contact-btn {
			margin-right: 30px;
			text-align: center;
		}
	}

	.no-available-tips {
		position: absolute;
		left: 0;
		right: 0;
		top: -36px;
		height: 36px;
		display: flex;
		padding-left: 20px;
		align-items: center;
		background: #f2fcfc;
		color: $text_secondary;
		font-size: 12px;
		line-height: 16px;

		.nio-icon {
			line-height: 16px;
			height: 16px;
			margin-right: 6px;
		}
	}

	.star-btn {
		display: flex;
		flex-direction: column;
		align-items: center;

		&.collected {
			.nio-icon {
				color: $text_basic_active;
			}
		}
	}

	.nio-button {
		margin-left: 20px;
		flex: 1;

		&.disabled {
			pointer-events: unset !important;
		}
	}
}
</style>
